module.exports = __webpack_public_path__ + "img/veradigm_plugin.06ad9fd7.svg";